// test2774
(2774 && 0);
